import React from 'react';
import AppPageLayout from 'layout/AppPagelayout';
import { ContentColors, PhoneFrame, Switch } from 'components';
import { Toolbar, Tabbar } from 'components/Applications';
import { LibraryHeader, LibraryContent } from 'components/Applications/library';
import { useConfigUsage } from 'provider/hooks/SvaraConfigHook';
import { colorUsage } from 'provider/context/defaultData';
import { ContentColorsItem } from 'components/AppPage/types';
import { createContentColorsItems } from 'utils/Colors';

const libraryColor = [
    colorUsage.color_primary,
    colorUsage.color_accent,
    colorUsage.background_1,
    colorUsage.background_3,
    colorUsage.background_4,
    colorUsage.text_1,
    colorUsage.icon_1,
    colorUsage.library_badge_color,
    colorUsage.library_badge_text_color,
    colorUsage.background_toolbar,
    colorUsage.text_toolbar,
    colorUsage.icon_toolbar,
    colorUsage.tab_layout_home,
    colorUsage.tab_layout_home_text,
    colorUsage.background_mini_player,
    colorUsage.text_mini_player,
];

const Library: React.FC = () => {
    const phoneWidth = '236px';
    const { isDark, setDark, getColor, hasDarkLightVarian } = useConfigUsage();

    const getColorsToShow = React.useCallback((): ContentColorsItem[] => {
        return createContentColorsItems(
            libraryColor,
            isDark,
            getColor,
            hasDarkLightVarian
        );
    }, [getColor, hasDarkLightVarian, isDark]);

    return (
        <AppPageLayout>
            <div className="w-full flex overflow-x-hidden relative">
                <div
                    className={`overflow-hidden p-4`}
                    style={{
                        width: `calc(100vw - ${phoneWidth})`,
                    }}
                >
                    <ContentColors contents={getColorsToShow()} />
                </div>
                <div
                    className={`flex grow-0 mx-4`}
                    style={{
                        width: phoneWidth,
                    }}
                >
                    <div className="flex flex-col fixed top-toolbar right-4 mt-4 gap-y-2">
                        <PhoneFrame
                            width={phoneWidth}
                            toolbar={<Toolbar title="LIBRARY" />}
                            tabbar={<Tabbar activeAt="library" />}
                        >
                            <LibraryHeader />
                            <LibraryContent />
                        </PhoneFrame>

                        <Switch
                            active={isDark}
                            onChange={setDark}
                            activeText="Dark"
                            offText="Light"
                            removeColorActive={false}
                            size="lg"
                        />
                    </div>
                </div>
            </div>
        </AppPageLayout>
    );
};

export default Library;
